'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssignmentInd(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#4978BB' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size + 8,
      viewBox: '0 0 18 20',
      xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M-3-1h24v24H-3z' }),
      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M16 2h-4.18C11.4.84 10.3 0 9 0 7.7 0 6.6.84 6.18 2H2C.9 2 0 2.9 0 4v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H3v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V18z' })
    )
  );
}

AssignmentInd.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

exports.default = AssignmentInd;